import { useMemo } from 'react';
import useAddressBookContacts from './useAddressBookContacts';
import useUserProfile from './useUserProfile';

const hasRole = (role, userProfile, participants) => () => {
  if (userProfile && participants && participants.length) {
    const participant = participants.find(p => p.userId === userProfile.id);
    return participant && participant.roles && participant.roles.includes(role);
  }
  return false;
};

const useSessionRoles = (participants = []) => {
  const { userProfile } = useUserProfile();
  const { staff } = useAddressBookContacts();
  const isModerator = useMemo(hasRole('moderator', userProfile, participants), [
    participants,
    userProfile,
  ]);
  const isOrganizer = useMemo(hasRole('organizer', userProfile, participants), [
    participants,
    userProfile,
  ]);
  const participant = participants.find(p => p.userId === userProfile.id);

  const isTeamMember = participants.some(({ userId }) =>
    staff.map(({ user }) => user.id).includes(userId),
  );

  const moderator = useMemo(() => {
    if (participants && participants.length) {
      return participants.find(p => p.roles && p.roles.includes('moderator'));
    }
    return null;
  }, [participants]);

  return {
    isModerator,
    isOrganizer,
    isParticipant: typeof participant !== 'undefined',
    isTeamMember,
    participant,
    moderator,
  };
};

export default useSessionRoles;
